$(document).ready(function() {

	let $window = $(window);
	let $header = $('#header');
	let $navControl = $('#menuControl');
	let $nav = $('#navbarMain');
	let navClosingOnPopstateStatus = true;
	let scrollTop = 0;

	$navControl.click(function (event) {
		if ($navControl.hasClass('active')) {
			history.back();
		}
		else {
			history.pushState(null, document.title, '#navbarMain');
			$window.scrollTop(0);
			$navControl.addClass('active');
		}

		event.preventDefault();

		return false;
	});

	$('a[href^="/"]').click(function (event) {
		if (!$navControl.hasClass('active')) {
			return;
		}

		let $this = $(this);

		if (location.pathname !== $this.attr('href')) {
			navClosingOnPopstateStatus = false;
		}

		history.back();

		if (location.pathname !== $this.attr('href')) {
			location.href = $this.attr('href');
		}

		event.preventDefault();

		return false;
	});

	$(document).click(function(event) {
		if ($navControl.hasClass('active')) {
			history.back();
		}
	});

	$window.on('popstate', function (event) {
		if ($navControl.hasClass('active') && navClosingOnPopstateStatus === true) {
			$nav.addClass('closing');

			setTimeout(function() {
				$nav.removeClass('closing');
				$navControl.removeClass('active');
			}, 300);
		}

		if ($navControl.hasClass('active') && navClosingOnPopstateStatus === false) {
			navClosingOnPopstateStatus = true;
		}
	});


	if ($window.scrollTop() > 700) {
		$header.addClass('hide-on-scroll-down');
	}

	$window.scroll(function () {
		if ($window.scrollTop() === 0) {
			$header.removeClass('show-on-scroll-up').removeClass('showing');
			return;
		}

		if ($window.scrollTop() <= 700) {
			$header.removeClass('hide-on-scroll-down').removeClass('hiding');

			return;
		}

		if (!$header.hasClass('show-on-scroll-up') && !$header.hasClass('hide-on-scroll-down')) {
			$header.addClass('hide-on-scroll-down');
		}

		if ($header.hasClass('show-on-scroll-up') && $window.scrollTop() < scrollTop) {
			scrollTop = $window.scrollTop();
		}
		else if ($header.hasClass('show-on-scroll-up') && $window.scrollTop() > (scrollTop + 10)) {
			scrollTop = $window.scrollTop();
			$header.removeClass('show-on-scroll-up').removeClass('showing');
			$header.addClass('hide-on-scroll-down').addClass('hiding');
		}
		else if ($header.hasClass('hide-on-scroll-down') && $window.scrollTop() > scrollTop) {
			scrollTop = $window.scrollTop();
		}
		else if ($header.hasClass('hide-on-scroll-down') && $window.scrollTop() < (scrollTop - 150)) {
			scrollTop = $window.scrollTop();
			$header.addClass('show-on-scroll-up').addClass('showing');
			$header.removeClass('hide-on-scroll-down').removeClass('hiding');
		}
	});
});
